import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import axios from 'axios';
import { checkAuth } from '@/utils/auth';
import tooltip from '@/directives/tooltip';
import { initTheme } from '@/composables/useTheme';
import { ensureAppearanceSettingsLoaded } from '@/composables/useAppearanceSettings';

import "./assets/tailwind.css";

// Axios default configurations
axios.defaults.withCredentials = true;
// Use relative URLs so Vite dev proxy forwards /api/* to the server (avoids CORS preflight).
// In production, ensure the app is served from the same origin as the API or configure your reverse proxy.
axios.defaults.baseURL = '';

localStorage.removeItem("savedCities");

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.directive('tooltip', tooltip);

// Attach the System media listener + run the one theme synchronization pass
// (seeds deviceMode from Cache A, applies the resolved theme). Unconditional.
initTheme();

// Resolve auth state before first render so route guards have accurate state on page refresh.
checkAuth().finally(() => {
  // One deduped canonical load of the member's appearance / workspace-default
  // preferences. Subsequent login/logout transitions are handled by the
  // auth watcher inside useAppearanceSettings.
  ensureAppearanceSettingsLoaded();
  app.mount('#app');
});
